export const environment = {
  production: false,
  api: "https://dev.mobapi-k8s.fincube.uz",
};
